import { Finyearmst, Txncategory, Purpose, Transaction, AccountsHeader, AccountsDetails } from "./tallyentry-api-model";

export class LedgerHead {
    public ledgerHeadId?: number;
    public name?: string;
    public entryType?: string;
    public isDeemedPositive?: boolean;
    public status?: string;
  
    constructor(init?: Partial<LedgerHead>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}

export class AccountsHeaderMapping {
  accountsheaderId?: number
  txndate?: string
  amount?: number
  bookNo?: number
  modeOfPayment?: string
  modeTranId?: string
  modeBankName?: string
  finyearmst = new Finyearmst();
  txncategory = new Txncategory();
  purpose = new Purpose();
  transaction = new Transaction();
  accountsDetails = new AccountsDetails();
  accountsMapping = new AccountsMapping();
  status?: boolean
  mapexternal?: boolean

  constructor(init?: Partial<AccountsHeaderMapping>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}

export class AccountsMapping {
  public accountsmappingId?: number;
  public accountsHeader = new AccountsHeader();
  public debitLedgerId?: number;
  public debitTo?: string;
  public creditLedgerId?: string;
  public creditTo?: string;
  public mappingsts?: boolean;

  constructor(init?: Partial<AccountsMapping>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}

export class TransactionMappingModel {
  public finyearmstId: number;
  public txncategoryId: number;
  public fromToDates: string;
  public bookNo: number;
  public receiptNo: number;
  public amount: number;
  public purpose: string;

  public creditToId: number;
  public debitToId: number;

  public fromDate: Date;
  public toDate: Date;

  constructor(init?: Partial<TransactionMappingModel>) { 
    Object.assign(this, init);
  }
}